module.exports = angular.module('cartographer.common.api.feature', [])

_ = require 'underscore'

module.exports.factory 'crtFeature', $DI (
  crtLog
  crtConfig
  crtPromise
  crtHttp
  crtLocation
  crtDatetime
  crtWorkspace
) ->
  _searchParams = (params = {}) ->
    return {
      workspace     : params.workspace
      ne            : if params.ne   then crtLocation.formatQueryParameter(params.ne) else undefined
      sw            : if params.sw   then crtLocation.formatQueryParameter(params.sw) else undefined
      from          : if params.from then crtDatetime.formatIso8601(params.from)      else undefined
      to            : if params.to   then crtDatetime.formatIso8601(params.to)        else undefined
      module        : params.module
      survey        : params.survey
      simplify      : params.simplify || false
      authorization : params.authorization
    }

  search = (layerId, params = {}) ->
    allParams = _.defaults(_searchParams(params), { format: 'legacy' })
    # crtLog.debug('crtFeature.search', layerId, allParams)
    crtHttp.get("#{crtConfig.api.rootUrl}/map/v1/#{layerId}", allParams)

  searchUrl = (layer, params = {}) ->
    filename    = if params.format then "#{layer.id}.#{params.format}" else layer.id
    queryParams = _.extend(_searchParams(params), { zoom: undefined })
    # crtLog.debug('crtFeature.searchUrl', layer.id, queryParams)
    crtHttp.url("#{crtConfig.api.rootUrl}/map/v1/#{filename}", queryParams)

  read = (workspace, layer, id, params = {}) ->
    allParams = _.defaults(params, { workspace, format: 'legacy' })
    crtHttp.get("#{crtConfig.api.rootUrl}/map/v1/#{layer}/#{id}", allParams, crtHttp.ignoreHandlers)

  # string string string { string: string } -> promiseOf(feature[])
  readBySurvey = (workspace, layerId, module, survey, params = {}) ->
    allParams = _.defaults(params, { format: 'legacy' })
    # crtLog.debug('crtFeature.readBySurvey', layerId, module, survey, params)
    search(layerId, _.extend(allParams, { module, survey, workspace }))

  _pickParams = (radius, params = {}) ->
    return {
      workspace : params.workspace
      radius    : radius
      exact     : if params.exact? then "#{params.exact}" else "false"
      format    : params.format
    }

  pick = (layer, point, radius, params = {}) ->
    allParams = _.defaults(_pickParams(radius, params), { format: 'legacy' })
    # crtLog.debug('crtFeature.pick', layer, point, allParams)
    crtHttp.get("#{crtConfig.api.rootUrl}/map/v1/#{layer}/pick/#{crtLocation.formatQueryParameter(point)}", allParams, crtHttp.ignoreHandlers)

  reset = (layer = undefined) ->
    if layer?
      crtHttp.get("#{crtConfig.api.rootUrl}/map/v1/#{layer}/reset", {}, crtHttp.ignoreHandlers)
    else
      crtHttp.get("#{crtConfig.api.rootUrl}/map/v1/reset", {}, crtHttp.ignoreHandlers)

  return {
    search
    searchUrl
    read
    readBySurvey
    pick
    reset
  }
